import { render, staticRenderFns } from "./ShareDetail.vue?vue&type=template&id=244039ab&scoped=true&"
import script from "./ShareDetail.vue?vue&type=script&lang=js&"
export * from "./ShareDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShareDetail.vue?vue&type=style&index=0&id=244039ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244039ab",
  null
  
)

export default component.exports